import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'

const selectionListStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    padding: '16px 20px',
    border: '1px solid #CADAE1',
    borderRadius: 8,
    backgroundColor: '#F7F9FB',
    maxWidth: 360,
    margin: '0 auto',
}

const VerbatimFilterWarningModal = ({ store }) => {
    const selections = store.verbatimFilterWarningOpen
        ? (store.activeChart?.verbatimSelections ?? [])
        : []

    return (
        <Modal
            show={store.verbatimFilterWarningOpen}
            onClose={store.cancelVerbatimFilterSave}
            nestedModal
        >
            <Typography type="h2">{i18n.t('powerpoint.verbatimFilterWarning.title')}</Typography>

            <br />

            <hr />

            <br />

            <Typography type="p">
                {i18n.t('powerpoint.verbatimFilterWarning.description', { count: selections.length })}
            </Typography>

            <br />

            <div style={selectionListStyle}>
                {selections.map(({ position, category, commentCount }) => (
                    <Typography key={position} type="tiny-b">
                        {i18n.t('powerpoint.verbatimFilterWarning.selection', {
                            category: category || i18n.t('powerpoint.verbatimFilterWarning.noCategory'),
                            count: commentCount,
                        })}
                    </Typography>
                ))}
            </div>

            <br />

            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                <Button
                    label={i18n.t('cancel')}
                    onClick={store.cancelVerbatimFilterSave}
                    cssClass="regular tertiary"
                />
                <Button
                    icon="fa-thin fa-save"
                    label={i18n.t('powerpoint.verbatimFilterWarning.submit')}
                    onClick={store.confirmVerbatimFilterSave}
                    cssClass="regular primary"
                />
            </div>
        </Modal>
    )
}

export default observer(VerbatimFilterWarningModal)
